import { Component, h, Host, Prop } from '@stencil/core';

import { ClassNames } from '../../utils/interfaces';

@Component({
  tag: 'patternlib-icon',
  styleUrl: 'patternlib-icon.scss',
  shadow: true,
})
export class PatternlibIcon {
  /**
   * Set an icon using the corresponding name from the icon font like "download", "edit" or "plus".
   */
  @Prop() iconName = 'download';

  /**
   * Set the width and height of the icon in px.
   */
  @Prop() size = '24px';

  /**
   * Define the fill color of the icon using a color variable.
   */
  @Prop() color?: string;

  /**
   * Define if the icon is to be rendered bold.
   */
  @Prop() bold = false;

  @Prop() disabled = false;
  @Prop() variant: 'dark' | 'light' = 'light';

  /**
   * Define the display style of the host element.
   */
  @Prop() display = 'block';

  render() {
    const iconClass: ClassNames = {
      [`${'icon-liebherr-' + this.iconName + '-icon-rgb-64px'}`]: true,
      disabled: this.disabled,
      dark: this.variant == 'dark',
    };

    const iconStyle = { fontSize: `${this.size}`, color: this.color, fontWeight: this.bold ? 'bold' : 'normal', display: 'flex', textAlign: 'center' };

    const icon = <span part="icon" class={iconClass} style={iconStyle}></span>;

    return <Host style={{ display: this.display }}>{icon}</Host>;
  }
}
